<template>
  <section class="forgot-password">
    <form class="forgot__password" @submit.prevent="forgotPassword">
      <img class="forgot-password__logo" src="@/assets/images/logo.svg" alt="Rumie"/>
      <label class="forgot-password__label">Password Recovery</label>
      <label style="font-size:15px">All instructions will be sent to your email.</label>
      <rum-input type="text" placeholder="Email" class="forget-form__username" v-model="username"/>

      <aside v-if="error" class="forgot-password__error">Something is not right, please try again.</aside>
      <rum-loader v-if="working" class="An email with the password reset link has been sent" center/>
      <div v-else class="forgot-password__actions">
        <rum-button type="submit" :disabled="disabled">Recover Password</rum-button>
        <router-link class="primary-link" :to="{name: 'Login'}">back to login</router-link>
      </div>
    </form>
    <aside class="login__welcome">
      <title class="login-welcome__message">
        Welcome to the<span class="login-welcome__message--primary">&nbsp;Rumie-Connect</span>
      </title>
    </aside>
  </section>
</template>

<script>
import api from "@/api";

export default {
  name: "ForgotPassword",
  data() {
    return {
      username: "",
      working: false,
      error: false
    };
  },
  computed: {
    disabled() {
      return !this.username;
    }
  },
  methods: {
    async forgotPassword() {
      try {
        this.error = false;
        this.working = true;
        const current = api();
        await current.post(`/forgot_password`,{
          email: this.username
        });
        this.working = false;
        this.$notify({
          type: "success",
          title: `An email with the password reset link has been sent to ${this.username}.`
        });
        this.username = "";
      } catch (e) {
        this.error = true;
        this.working = false;
      } 
    }
  }
};
</script>

<style scoped>
.forgot-password {
  background: var(--white);
  height: 100vh;
  width: 100vw;
  display: flex;
  box-sizing: border-box;
}

.forgot__password {
  width: 25%;
  background: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding: var(--spacing-8);
}

.forgot-password__logo {
  display: none;
}

.forgot-password__label {
  font-weight: bold;
  margin-bottom: var(--spacing-6);
}

.forget-form__username {
  margin-bottom: var(--spacing-2);
  margin-top: var(--spacing-4);
}

.login-form__password {
  margin-bottom: var(--spacing-2);
}

.forgot-password__error {
  color: var(--red-dark);
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
  font-weight: var(--bold);
  font-size: var(--xs);
}

.forgot-password__success {
  color: var(--green-light);
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
  font-weight: var(--bold);
  font-size: var(--xs);
}

.forgot-password__loader {
  margin-top: var(--spacing-8);
}

.forgot-password__actions {
  margin-top: var(--spacing-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login__welcome {
  width: 75%;
  /* height: 100%; */
  background: #474450;
  background-image: url("~@/assets/images/login-welcome.png");
  background-size: cover;
}

.login-welcome__message {
  font-size: var(--xl5);
  font-weight: var(--light);
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.login-welcome__message--primary {
  color: var(--orange);
}

@media screen and (max-width:1100px) {
  .forgot-password__actions {
    flex-direction: column;
  }

  .primary-link {
    margin-top: var(--spacing-2);
  }
}

@media screen and (max-width: 900px) {
  .forgot__password {
    width: 100%;
  }

  .forgot-password__actions {
    flex-direction: row;
  }

  .forgot-password__logo {
    display: block;
    margin-bottom: var(--spacing-16);
    height: 34px;
  }

  .login__welcome {
    display: none;
  }
}
</style>
